/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Comparison } from './Comparison';
import {
    ComparisonFromJSON,
    ComparisonFromJSONTyped,
    ComparisonToJSON,
    ComparisonToJSONTyped,
} from './Comparison';

/**
 * Paginated list of comparisons
 * @export
 * @interface ListComparisonsResponse
 */
export interface ListComparisonsResponse {
    /**
     * List of comparisons
     * @type {Array<Comparison>}
     * @memberof ListComparisonsResponse
     */
    items: Array<Comparison>;
    /**
     * Total number of comparisons
     * @type {number}
     * @memberof ListComparisonsResponse
     */
    total: number;
    /**
     * Current page number
     * @type {number}
     * @memberof ListComparisonsResponse
     */
    page: number;
    /**
     * Items per page
     * @type {number}
     * @memberof ListComparisonsResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the ListComparisonsResponse interface.
 */
export function instanceOfListComparisonsResponse(value: object): value is ListComparisonsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function ListComparisonsResponseFromJSON(json: any): ListComparisonsResponse {
    return ListComparisonsResponseFromJSONTyped(json, false);
}

export function ListComparisonsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListComparisonsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ComparisonFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function ListComparisonsResponseToJSON(json: any): ListComparisonsResponse {
    return ListComparisonsResponseToJSONTyped(json, false);
}

export function ListComparisonsResponseToJSONTyped(value?: ListComparisonsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ComparisonToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

